function subscribeToNews(aSubscribeUrl, aNewsSections)
{
    if (typeof aSubscribeUrl === 'undefined') return;

    var newsSections = (typeof aNewsSections === 'undefined') ? '' : aNewsSections;
    var loadingHtml = '<div class="fbcms_news_grid_loading">'
        + '<img src="/img/spacer.gif" alt="Loading Subscriptions..." title="Loading Subscriptions..."/>'
        + '<div>Loading Subscriptions...</div>'
        + '</div>';

    var errorHtml ='<div class="fbcms_news_grid_error">'
        + '<img src="/img/spacer.gif" alt="Error Loading Subscriptions." title="Error Loading Subscriptions."/>'
        + '<div>Error Loading Subscriptions.</div>'
        + '</div>';

    $('#subscribe_news_dialog').remove();
    $('body').append('<div id="subscribe_news_dialog" title="Subscribe to News Categories"></div>');
    $('#subscribe_news_dialog').html(loadingHtml).dialog(
    {
        title: "Subscribe to News Categories",
        width: 600,
        height: 400,
        modal: true,
        close: function (_event, _ui)
        {
            $(this).dialog('destroy').remove();
        },
        open: function (_event, _ui)
        {
            FBUtilities.UpdateWidgetOverlayStyle(this);

            $.ajax(aSubscribeUrl, {
                success: function (data, _textStatus, _jqXHR)
                {
                    $('#subscribe_news_dialog').html(data);
                    $('#subscribe_news_dialog').find("input.feed_url").click(function ()
                    {
                        this.select();
                    });
                },
                error: function (_jqXHR, _textStatus, _errorThrown)
                {
                    $('#subscribe_news_dialog').html(errorHtml);
                },
                data:
                {
                    NewsSections: newsSections,
                    rndm: Math.random()
                },
                type: 'GET'
            });
        }
    });
}
